import PropTypes from 'prop-types';

import { Content, Inner } from './periodic-tariffication.styled';
import { PeriodsLoop } from './periods/periods-loop/periods-loop';
import { PeriodsSimple } from './periods/periods-simple/periods-simple';

export const PeriodicTariffication = (props) => {
  const { color, display, ...rest } = props;
  const isLoop = true;
  const PeriodsCmp = isLoop ? PeriodsLoop : PeriodsSimple;

  return (
    <Content color={color} style={{ display: display ? 'block' : 'none' }}>
      <Inner>
        <PeriodsCmp {...rest} />
      </Inner>
    </Content>
  );
};

PeriodicTariffication.propTypes = {
  selectedZone: PropTypes.any,
  show: PropTypes.bool,
  disabled: PropTypes.bool,
  newIndividual: PropTypes.bool,
};
